import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NGXLogger } from 'ngx-logger';
import {
    QuestionnaireSanteSimplifieService,
    ReponseQuestionnaireSanteSimplifie,
    EspaceClientService,
    AuthenticationService,
    EspaceDocumentaireService,
    QuestionnaireSanteService,
    User,
} from '@kv-common-components/kx-services';
import { collapse } from '@shared/animations/animations';
import { QuestionSimpleComponent } from '@shared/components/qs-questions/question-simple/question-simple.component';
import { QuestionTailleComponent } from '@shared/components/qs-questions/question-taille/question-taille.component';
import { RouterHelperService } from '@shared/services/router-helper.service';
import { ContextDossier } from '@kv-common-components/kv-common-components';
import { QsPreFedService } from './qs-pre-fed.service';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-qss-component',
    animations: [collapse],
    templateUrl: './qss.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QssComponent implements OnInit, OnDestroy {
    @ViewChildren(QuestionSimpleComponent)
    questionSimpleComponents!: QueryList<QuestionSimpleComponent>;
    @ViewChildren(QuestionTailleComponent)
    questionTailleComponents!: QueryList<QuestionTailleComponent>;

    currentUser: User;
    versionPapierCollapsed = true;
    listeQuestionsQuestionnaireSanteSimplifie: any[];
    preambuleQuestionsSanteSimplifie: any;
    qssForm: FormGroup;

    qssLoading = false;
    submitLoading = false;
    saveLoading = false;
    showSuccesModal = false;

    isSaveForNextAdhChecked = false;
    goBackToEspaceClientModal = false;
    noChangesModal = false;
    postValidateQssModal = false;

    previousAnswer: ReponseQuestionnaireSanteSimplifie[] = [];
    questionnaireSanteSubscription: Subscription;

    private storedSubmitData: any;

    constructor(
        private espaceClientService: EspaceClientService,
        private questionnaireSanteService: QuestionnaireSanteService,
        private authenticationService: AuthenticationService,
        private questionnaireSanteSimplifieService: QuestionnaireSanteSimplifieService,
        public routerHelperService: RouterHelperService,
        private router: Router,
        private logger: NGXLogger,
        public espaceDocumentaireService: EspaceDocumentaireService,
        public qsPreFedService: QsPreFedService,
        public changeDetectorRef: ChangeDetectorRef
    ) {
        this.qssLoading = true;
    }
    ngOnInit(): void {
        this.qssForm = new FormGroup({});
        this.currentUser = this.authenticationService.currentUserValue;
        this.questionnaireSanteService.initializeData(
            this.currentUser.idPersonne,
            this.currentUser.idDossier
        );
        this.questionnaireSanteSubscription =
            this.questionnaireSanteService.currentQuestionnaireSante
                .pipe(take(1))
                .subscribe((data) => {
                    this.qssLoading = false;
                    this.listeQuestionsQuestionnaireSanteSimplifie =
                        data.listeQuestionsQuestionnaireSanteSimplifie;
                    this.preambuleQuestionsSanteSimplifie =
                        data.preambuleQuestionsSanteSimplifie;
                    this.changeDetectorRef.detectChanges();
                    this.initQssReponses();
                });
    }

    ngOnDestroy() {
        if (this.questionnaireSanteSubscription) {
            this.questionnaireSanteSubscription.unsubscribe();
        }
    }

    initQssReponses() {
        const idPersonne = this.currentUser.idPersonne.toString();
        const idDossier = this.currentUser.idDossier.toString();

        let methodeEspaceClient = 'refreshEspaceClient';
        if (this.routerHelperService.previousUrl === '') {
            methodeEspaceClient = 'getrefreshedEspaceClient';
        }
        this.espaceClientService[methodeEspaceClient](
            this.authenticationService.currentUserValue.idPersonne
        ).subscribe((data) => {
            const contextDossier =
                ContextDossier.initContextDossierFromEspaceClient(
                    idPersonne,
                    idDossier,
                    data
                );
            const listeReponsesQuestionsSanteSimplifie =
                contextDossier.emprunteur.assurance
                    .listeReponsesQuestionsSanteSimplifie;
            if (
                listeReponsesQuestionsSanteSimplifie &&
                listeReponsesQuestionsSanteSimplifie.length > 0
            ) {
                this.qsPreFedService.setPreviousQssResponses(
                    listeReponsesQuestionsSanteSimplifie,
                    this.qssForm
                );
                this.changeDetectorRef.detectChanges();
                this.previousAnswer = listeReponsesQuestionsSanteSimplifie;
            }
        });
    }

    postValidateQss() {
        this.submitLoading = true;
        const idPersonne = this.currentUser.idPersonne;
        const idPropositionPrincipale =
            this.currentUser.idPropositionPrincipale;
        this.espaceClientService
            .refreshEspaceClient(idPersonne)
            .subscribe(() => {
                this.espaceDocumentaireService
                    .getEspaceDocumentaire(idPersonne, idPropositionPrincipale)
                    .subscribe(() => {
                        this.submitLoading = false;
                        this.routerHelperService.navigateAfterQSS(
                            this.storedSubmitData
                        );
                    });
            });
    }
    validateQss(f: FormGroup) {
        if (f.valid) {
            this.submitLoading = true;
            const reponses = this.getReponses();
            const idPersonne = this.currentUser.idPersonne;
            const idDossier = this.currentUser.idDossier;

            if (this.isSaveForNextAdhChecked) {
                this.questionnaireSanteService
                    .saveForNextAdh(idPersonne, idDossier, null, reponses, true)
                    .subscribe((data) => {
                        this.logger.info(
                            'questionnaireSanteService.saveForNextAdh : Success'
                        );
                    });
            }
            this.questionnaireSanteSimplifieService
                .postValidation(idPersonne, idDossier, reponses, true)
                .toPromise()
                .then((data) => {
                    this.logger.info(
                        'QuestionnaireSanteSimplifieService.postValidation response : ',
                        { data }
                    );
                    this.storedSubmitData = data;

                    this.postValidateQss();
                });
        } else {
            this.setAllControlsAsDirty(f);
        }
    }

    saveQss() {
        this.saveLoading = true;
        const reponses = this.getReponses();
        if (!this.responseArrayAreEquals(this.previousAnswer, reponses)) {
            const idPersonne = this.currentUser.idPersonne;
            const idDossier = this.currentUser.idDossier;
            //On appelle le webservice KX d enregistrement des reponses du QS
            this.questionnaireSanteService
                .postEnregistrement(idPersonne, idDossier, null, reponses)
                .toPromise()
                .then(() => {
                    this.logger.info(
                        'QuestionnaireSanteService.postEnregistrement : Success'
                    );
                    this.saveLoading = false;
                    this.showSuccesModal = true;
                    this.previousAnswer = reponses;
                    this.changeDetectorRef.detectChanges();
                })
                .catch((reason) => {
                    this.logger.error(
                        'QuestionnaireSanteService.postEnregistrement : Failed',
                        reason
                    );
                    this.saveLoading = false;
                    this.changeDetectorRef.detectChanges();
                    throw reason;
                });
        } else {
            this.noChangesModal = true;
            this.saveLoading = false;
        }
    }

    goBack() {
        this.goBackToEspaceClientModal = true;
    }
    navigateToEspaceClient() {
        this.router.navigateByUrl('espace-client/tableau-de-bord');
    }

    private getReponses(): ReponseQuestionnaireSanteSimplifie[] {
        //On collecte toutes les reponses et les sous-reponses
        const reponses: ReponseQuestionnaireSanteSimplifie[] = [];
        this.questionTailleComponents.forEach((questionTailleComponent) => {
            reponses.push(questionTailleComponent.getReponse());
        });
        this.questionSimpleComponents.forEach((questionSimpleComponent) => {
            reponses.push(questionSimpleComponent.getReponse());
        });

        //On trie les reponses selon leur id
        reponses.sort((r1, r2) => Number(r1.id) - Number(r2.id));
        return reponses;
    }

    private responseArrayAreEquals(
        array1: ReponseQuestionnaireSanteSimplifie[],
        array2: ReponseQuestionnaireSanteSimplifie[]
    ): boolean {
        return (
            array1.length === array2.length &&
            array1.every((value, index) =>
                this.reponsesEquals(value, array2[index])
            )
        );
    }

    private reponsesEquals(
        r1: ReponseQuestionnaireSanteSimplifie,
        r2: ReponseQuestionnaireSanteSimplifie
    ) {
        return (
            r1.id === r2.id &&
            r1.ouiNon === r2.ouiNon &&
            r1.poids === r2.poids &&
            r1.tailleCm === r2.tailleCm &&
            r1.tailleM === r2.tailleM
        );
    }

    private setAllControlsAsDirty(f: FormGroup) {
        Object.keys(f.controls).forEach((key) => {
            f.controls[key].markAsDirty();
        });
    }
}
